<template>
  <ontos-base v-bind="baseProps" ref="base">
    <div v-if="loaded && domain">
      <ontos-page-header v-bind="heading">
        <template #actions>
          <ontos-header-action v-if="can('designer')" icon="mdi-pencil" :label="$tt('edit')"
                               :to="{name: 'edit-domain', params: $route.params}"/>
          <ontos-header-action v-if="can('designer')" icon="mdi-delete" :label="$tt('delete')"
                               color="error" @click="deleteThis"/>
        </template>
      </ontos-page-header>
      <ontos-info-row>
        <ontos-view-info :title="$tt('domain-name')">{{ domain.name }}</ontos-view-info>
        <ontos-view-info :title="$tt('alias')"><span class="ontos-code">{{ domain.alias }}</span></ontos-view-info>
      </ontos-info-row>
      <!-- O chip de valor: é assim que a opção aparece nos itens -->
      <ontos-colored-entry-list :entries="domain.options" :title="$tt('options')" dense/>
    </div>
  </ontos-base>
</template>
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import OntosViewInfo from "@/components/shared/ViewInfo.vue";
import InfoRow from "@/components/shared/InfoRow.vue";
import ColoredEntryList from "@/components/shared/ColoredEntryList.vue";
import DomainLevelRouteComponent from "@/components/shared/DomainLevelRouteComponent";
import {domainDesign} from "@/utils/heading";
import {domainErrorMessage} from "@/utils/domainErrors";
import {workspaceDesignRoute} from "@/utils/breadcrumb";

@Component({components: {OntosViewInfo, 'ontos-info-row': InfoRow, 'ontos-colored-entry-list': ColoredEntryList}})
class ViewDomain extends DomainLevelRouteComponent {
  get heading() {
    return domainDesign(this.domain!)
  }

  async load() {
    if (!this.domain) this.throwError(this.$tt('error.load-domain', {name: this.$route.params.domain}))
  }

  async deleteThis() {
    const name = this.domain.name
    try {
      await this.deleteCurrentDomain()
      this.info(this.$tt('info.domain-deleted', {name}))
      await this.$router.push(workspaceDesignRoute(this.$route.params.system as string, 'domains'))
    } catch (err) {
      this.throwError(domainErrorMessage(err, this.$tt('error.delete-domain', {name})), err)
    }
  }
}

export default toNative(ViewDomain)
</script>
